import { render, staticRenderFns } from "./PrivacyConsent.vue?vue&type=template&id=5a55b94d&"
import script from "./PrivacyConsent.vue?vue&type=script&lang=js&"
export * from "./PrivacyConsent.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyConsent.vue?vue&type=style&index=0&id=5a55b94d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports